import { getScoreLetterFromKgeCO2PerParticipant } from '@/domain/impact-calculate/utils/get-score-letter-from-co2-per-participant';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { CalculateFestivalCo2 } from '../entities/calculate-festival-co2.entity';
import { computeKgCo2ByParticipantFestival } from './utils/compute-kg-co2-by-participant-festival';

type Params = {
  projectId: number;
};

type Result = {
  co2: CalculateFestivalCo2;
};

export const runImpactCalculateFestivalCo2ForProject = createAppAsyncThunk(
  'impactCalculateFestival/runImpactCalculateFestivalCo2ForProject',
  async (
    params: Params,
    { extra: { impactCalculateFestivalGateway, snackbarGateway }, getState },
  ): Promise<Result> => {
    try {
      let calculateCo2 =
        await impactCalculateFestivalGateway.runImpactCalculateFestivalCo2ForProject(
          params.projectId,
        );
      const kgeCO2ByParticipant = computeKgCo2ByParticipantFestival(
        getState(),
        calculateCo2,
        params.projectId,
      );
      const scoreLetter = getScoreLetterFromKgeCO2PerParticipant(
        kgeCO2ByParticipant,
        'festival',
      );
      calculateCo2 = { ...calculateCo2, scoreLetter, kgeCO2ByParticipant };
      return { co2: calculateCo2 };
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetImpactCalculate.Message.error'));
}
